import React from 'react'
import { AccountDeleted } from '../account-delete'

export interface AccountDeleteProps {
    masthead: string
    contactEmail: string
}
export const AccountDelete = ({
    masthead,
    contactEmail,
}: AccountDeleteProps) => (
    <>
        <AccountDeleted
            title={'Your account has been deleted'}
            paragraph={
                <>
                    Your account with {masthead} has been deleted as requested.
                    If you have any concerns, contact us at {contactEmail}.
                </>
            }
            backHomeButton={{ show: true, text: 'Back to home' }}
        />
    </>
)
